import { Injectable } from '@angular/core';

export type MarketingUpgradeContext = {
  tier?: string;
};

@Injectable({ providedIn: 'root' })
export class MarketingUpgradeService {
  private context: MarketingUpgradeContext | null = null;

  get(): MarketingUpgradeContext | null {
    return this.context;
  }

  set(context: MarketingUpgradeContext): void {
    this.context = context;
  }

  clear(): void {
    this.context = null;
  }
}
